module.exports = __webpack_public_path__ + "media/images/competition-banner-bg-bcadd76e91f8c19f37e42eed4f191b7a.png";